export const APP_INSTALL = 'APP_INSTALL';
export const REDUX_REMEMBER_PREFIX = 'REDUX_REMEMBER/';
